
export default {
    name: 'recommendCode',
    data() {
        return {
            saleLink: {},
            user_data: {}
        }
    },
    created() {
        document.title = "购票推荐码";
        // 获取当前登录者信息
        this.$UtilsApi.memberInfo({}).then(res => {
            if (res.data.code == 0) {
                this.user_data = res.data.data;
                console.log(this.user_data)
            }
        });
        // 获取推荐码列表
        const url = decodeURIComponent(this.$route.query.url || '');
        const name = this.$route.query.name || '';
        this.saleLink = {
            mall_name: name,
            sale_code_url: url,
        }
    }
}